import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { handleIOSSafariUA } from '@helsenorge/core-utils/user-agents-utils';
import { getCanShowHjelpetekstInPageHeader } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import LanguageProvider from '@helsenorge/framework-utils/components/language-provider';
import { getPath, getSidetittelId } from '@helsenorge/framework-utils/hn-page';
import { getVisPersonvelger } from '@helsenorge/framework-utils/hn-user';
import useResources from '@helsenorge/framework-utils/resources/useResources';
import { hasSamtykke } from '@helsenorge/framework-utils/samtykke-utils';
import Breadcrumb from '../breadcrumb';
import { getRedirectToUrlAfterLogin, getDelAvForeldresamtykke } from '../common/configuration';
import ErrorBoundary from '../error-boundary';
import FeedbackContainer from '../feedback/container';
import LanguagePickerWrapper from '../language-picker-wrapper';
import PageHeader from '../page-header';
import Personvelger from '../personvelger';
import { getResources, Projects } from '../resources';
import { useAppSelector } from '../store/hooks';
import './styles.scss';
const Master = props => {
    const { title, description, mainAriaLabelledby, tjenesteNavn = getPath(), className, visPersonvelger = getVisPersonvelger(), breadcrumbLink, redirectTo, hasFullwidth, noBreadcrumb = false, noDriftspanel, noLanguagePicker, showFeedbackForm, hasPageHeader = true, headerClassName, headerSubtitleClassName, headerTitleClassName, headerIngressClassName, subtitle, hjelpetekstId, showHjelpeskuffInPageHeader, } = props;
    const resources = useResources(Projects.FRAMEWORK, getResources);
    const redirectToUrlAfterLogin = getRedirectToUrlAfterLogin();
    const canShowHjelpetekstInPageHeader = useAppSelector(state => getCanShowHjelpetekstInPageHeader(state, tjenesteNavn, hjelpetekstId));
    const showHjelpeskuffInPageHeaderState = !!showHjelpeskuffInPageHeader && canShowHjelpetekstInPageHeader;
    useEffect(() => {
        handleIOSSafariUA();
        if (props.mount) {
            props.mount();
        }
    }, []);
    const getTitleId = () => {
        if (mainAriaLabelledby) {
            return mainAriaLabelledby;
        }
        if (title && hasPageHeader) {
            return getSidetittelId();
        }
    };
    if (visPersonvelger && hasSamtykke()) {
        return _jsx(Personvelger, { redirectTo: redirectTo, redirectToUrlAfterLogin: redirectToUrlAfterLogin });
    }
    return (_jsxs("div", { className: className, children: [!noDriftspanel && _jsx("hn-webcomp-driftspanel", {}), !noBreadcrumb && _jsx(Breadcrumb, { link: breadcrumbLink }), !noLanguagePicker && _jsx(LanguagePickerWrapper, {}), _jsxs("main", { className: !hasFullwidth ? 'container' : '', "aria-labelledby": getTitleId(), children: [hasPageHeader && (_jsx(PageHeader, { title: title, titleId: getTitleId(), subtitle: subtitle, showHjelpetrigger: showHjelpeskuffInPageHeaderState, delAvForeldresamtykke: getDelAvForeldresamtykke(), description: description, tjenesteNavn: tjenesteNavn, headerClassName: headerClassName, headerSubtitleClassName: headerSubtitleClassName, headerTitleClassName: headerTitleClassName, headerIngressClassName: headerIngressClassName })), resources && (_jsxs(ErrorBoundary, { resources: resources, children: [_jsx(LanguageProvider, { children: props.children }), showFeedbackForm && _jsx(FeedbackContainer, { url: getPath(), pageTitle: title ?? 'Uten tittel', tjenesteNavn: tjenesteNavn })] }))] })] }));
};
export default Master;
